var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06762 4.73529C9.06762 3.08656 10.4042 1.75 12.0529 1.75C13.7016 1.75 15.0382 3.08656 15.0382 4.73529V15.3324C15.5227 15.8463 15.8679 16.4783 16.0374 17.1682C16.236 17.9769 16.1839 18.8269 15.888 19.6053C15.592 20.3837 15.0662 21.0535 14.3804 21.5259C13.6946 21.9983 12.8813 22.2509 12.0486 22.25C11.2158 22.2491 10.4031 21.9949 9.71829 21.521C9.0335 21.0472 8.5091 20.3762 8.21477 19.5972C7.92045 18.8182 7.87012 17.9681 8.07049 17.1598C8.24074 16.4731 8.58511 15.8442 9.06762 15.3324V4.73529ZM10.561 15.4529C10.6262 15.7156 10.5465 16.0047 10.3296 16.1963C9.93368 16.546 9.65354 17.008 9.52642 17.5208C9.39931 18.0335 9.43123 18.5729 9.61796 19.0671C9.80468 19.5613 10.1374 19.9869 10.5718 20.2875C11.0062 20.5881 11.5219 20.7494 12.0502 20.75C12.5785 20.7506 13.0944 20.5903 13.5295 20.2907C13.9645 19.991 14.2981 19.566 14.4859 19.0722C14.6736 18.5784 14.7067 18.0391 14.5807 17.5261C14.4546 17.013 14.1755 16.5505 13.7803 16.1999C13.5675 16.0111 13.4874 15.7284 13.5472 15.4695C13.5413 15.4315 13.5382 15.3926 13.5382 15.3529V4.73529C13.5382 3.91499 12.8732 3.25 12.0529 3.25C11.2326 3.25 10.5676 3.91499 10.5676 4.73529V15.3529C10.5676 15.3868 10.5654 15.4202 10.561 15.4529Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6499 18.4C10.6499 17.6268 11.2767 17 12.0499 17H12.0599C12.8331 17 13.4599 17.6268 13.4599 18.4C13.4599 19.1732 12.8331 19.8 12.0599 19.8H12.0499C11.2767 19.8 10.6499 19.1732 10.6499 18.4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.08 9.25C12.4942 9.25 12.83 9.58579 12.83 10V18.5C12.83 18.9142 12.4942 19.25 12.08 19.25C11.6657 19.25 11.33 18.9142 11.33 18.5V10C11.33 9.58579 11.6657 9.25 12.08 9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.d79e4cc75f783fa6cb8b942d21e91458.svg";
export { ForwardRef as ReactComponent };